// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"login_loginForm__3-eNC","loginInput":"login_loginInput__PNpxc","loginSubmit":"login_loginSubmit__3PWKz"};